import styled, { css } from "styled-components"
import { StyledMikanSpan } from "@components/Mikan/Mikan.styled"

const StyledMenuItem = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 30px;
  row-gap: 4px;
  border-top: 1px solid var(--grey-40);
  position: relative;
  padding: 1.9rem 0;

  & a {
    width: fit-content;

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-column: 2/3;
    }
  }

  p {
    a > ${StyledMikanSpan} {
      display: inline-block;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      grid-column: 2/3;
    }
  }

  & ::before {
    content: "";
    width: 7px;
    height: 7px;
    background-color: #c4c4c4;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateY(-50%);
  }

  & ::after {
    content: "";
    width: 7px;
    height: 7px;
    background-color: #c4c4c4;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateY(-50%);
  }

  & p:empty {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }

  ${(props) =>
    props.withIcon &&
    css`
      .rt-icon {
        display: none;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        .rt-icon {
          display: block;
          height: max-content;
          align-self: center;

          /* Temporary fix for ScalableA icon on careers */
          svg path {
            fill: inherit;
          }
        }

        grid-template-rows: 34px 1fr auto;
        grid-template-columns: 1rem 1fr 1fr;

        & a {
          grid-column: 3/4;
          grid-row: 3/4;
        }

        & p {
          grid-row: 1/3;
          grid-column: 3/4;
        }
      }
    `}
`

export const DetailMenu = ({ items, withIcon }) => {
  // TODO: missing a key on this iterator
  // eslint-disable-next-line react/jsx-key
  return <>{items && items.map((item) => <StyledMenuItem withIcon={withIcon}>{item}</StyledMenuItem>)}</>
}

export default DetailMenu
